import { render } from "./bigScreen.vue?vue&type=template&id=47d8f7d6&scoped=true"
import script from "./bigScreen.vue?vue&type=script&lang=js"
export * from "./bigScreen.vue?vue&type=script&lang=js"

import "./bigScreen.vue?vue&type=style&index=0&id=47d8f7d6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d8f7d6"]])

export default __exports__